import axios from "axios";
import {
  defaultEndPointDetails,
  getTokenForFiber,
  getValidTokenV3,
} from "../utils/const.utils";

export function getSwapApi(
  sourceWalletAddress,
  sourceTokenContractAddress,
  sourceNetworkChainId,
  sourceAssetType,
  sourceAmount,
  sourceBridgeAmount,
  sourceOneInchData,
  sourceOneInchSelector,
  destinationWalletAddress,
  destinationTokenContractAddress,
  destinationNetworkChainId,
  destinationAssetType,
  destinationOneInchData,
  destinationAmountIn,
  destinationAmountOut,
  destinationAmount,
  gasPrice
) {
  return axios.get(
    `${defaultEndPointDetails.fiberBaseUrl}/api/v1/multiswap/swap/signed?sourceWalletAddress=${sourceWalletAddress}&sourceTokenContractAddress=${sourceTokenContractAddress}&sourceNetworkChainId=${sourceNetworkChainId}&destinationTokenContractAddress=${destinationTokenContractAddress}&destinationNetworkChainId=${destinationNetworkChainId}&sourceAmount=${sourceAmount}&sourceBridgeAmount=${sourceBridgeAmount}&destinationWalletAddress=${destinationWalletAddress}&sourceAssetType=${sourceAssetType}&destinationAssetType=${destinationAssetType}&sourceOneInchData=${sourceOneInchData}&destinationOneInchData=${destinationOneInchData}&destinationAmountIn=${destinationAmountIn}&destinationAmountOut=${destinationAmountOut}&destinationAmount=${destinationAmount}&gasPrice=${gasPrice}&sourceOneInchSelector=${sourceOneInchSelector}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${getTokenForFiber()}`,
      },
    }
  );
}

export function getEstimatedSwapTime(sourceNetworkId, destinationNetworkId) {
  return axios.get(
    `${defaultEndPointDetails.baseUrl}/api/v1/estimatedSwapTimeByNetwork/by/network?sourceNetworkId=${sourceNetworkId}&destinationNetworkId=${destinationNetworkId}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
      },
    }
  );
}

export async function doSwapAndWithdrawTxAfterSwapApi(
  transactionHash,
  sourceNetworkId,
  sourceCabnId,
  sourceAssetType,
  sourceAmount,
  sourceBridgeAmount,
  sourceOneInchData,
  sourceOneInchSelector,
  destinationNetworkId,
  destinationCabnId,
  destinationAssetType,
  destinationOneInchData,
  destinationAmountIn,
  destinationAmountOut,
  destinationOneInchSelector,
  gasPrices,
  slippage
) {
  return axios.post(
    `${defaultEndPointDetails.baseUrl}/api/v1/community-member/multiSwap/transactions/do/swap/and/withdraw/${transactionHash}?sourceNetworkId=${sourceNetworkId}&destinationNetworkId=${destinationNetworkId}&sourceCabnId=${sourceCabnId}&destinationCabnId=${destinationCabnId}&slippage=${slippage}`,
    {
      sourceAssetType: sourceAssetType,
      destinationAssetType: destinationAssetType,
      sourceAmount: sourceAmount,
      sourceBridgeAmount: sourceBridgeAmount,
      destinationAmountIn: destinationAmountIn,
      destinationAmountOut: destinationAmountOut,
      sourceOneInchData: sourceOneInchData,
      destinationOneInchData: destinationOneInchData,
      gasPrices: gasPrices,
      sourceOneInchSelector,
      destinationOneInchSelector,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${await getValidTokenV3()}`,
      },
    }
  );
}

export async function getSwapTransactionHashReceipt(
  transactionHash,
  sourceNetworkId
) {
  return axios.get(
    `${defaultEndPointDetails.baseUrl}/api/v1/community-member/multiSwap/transactions/receipt/by/hash/${transactionHash}?sourceNetworkId=${sourceNetworkId}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${await getValidTokenV3()}`,
      },
    }
  );
}

export async function getAllSwapAndWithdrawTransactionsApi(offset, txId) {
  return axios.get(
    `${defaultEndPointDetails.baseUrl}/api/v1/community-member/multiSwap/transactions/list?transactionHash=${txId}&offset=${offset}&limit=10`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${await getValidTokenV3()}`,
      },
    }
  );
}

export function getGasEstimationForSourceAndDestination(
  walletAddress,
  sourceChainId,
  destinationChainId,
  sourceTokenContractAddress,
  destinationTokenContractAddress,
  amount
) {
  return axios.get(
    `${defaultEndPointDetails.forgeBaseUrl}/api/v1/gasEstimation/for/source/and/destination?walletAddress=${walletAddress}&sourceChainId=${sourceChainId}&destinationChainId=${destinationChainId}&sourceTokenContractAddress=${sourceTokenContractAddress}&destinationTokenContractAddress=${destinationTokenContractAddress}&amount=${amount}&smartContractAddress=0x8e01cc26d6dd73581347c4370573ce9e59e74802`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
      },
    }
  );
}

export function getTokenCategorizedAndQuoteInformation(
  sourceWalletAddress,
  sourceTokenContractAddress,
  sourceNetworkChainId,
  sourceAmount,
  destinationAddress,
  destinationTokenContractAddress,
  destinationNetworkChainId,
  slippage
) {
  return axios.get(
    `${defaultEndPointDetails.fiberBaseUrl}/api/v1/multiswap/token/categorized/quote/info?sourceWalletAddress=${sourceWalletAddress}&sourceTokenContractAddress=${sourceTokenContractAddress}&sourceNetworkChainId=${sourceNetworkChainId}&sourceAmount=${sourceAmount}&destinationTokenContractAddress=${destinationTokenContractAddress}&destinationNetworkChainId=${destinationNetworkChainId}&destinationWalletAddress=${destinationAddress}&slippage=${slippage}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${getTokenForFiber()}`,
      },
    }
  );
}
export function getFakeTokenCategorizedAndQuoteInformation(
  sourceWalletAddress,
  sourceTokenContractAddress,
  sourceNetworkChainId,
  sourceAmount,
  destinationAddress,
  destinationTokenContractAddress,
  destinationNetworkChainId,
  slippage,
  gasEstimationDestinationAmount
) {
  return axios.get(
    `${defaultEndPointDetails.fiberBaseUrl}/api/v1/multiswap/token/categorized/quote/info?sourceWalletAddress=${sourceWalletAddress}&sourceTokenContractAddress=${sourceTokenContractAddress}&sourceNetworkChainId=${sourceNetworkChainId}&sourceAmount=${sourceAmount}&destinationTokenContractAddress=${destinationTokenContractAddress}&destinationNetworkChainId=${destinationNetworkChainId}&destinationWalletAddress=${destinationAddress}&gasEstimationDestinationAmount=${gasEstimationDestinationAmount}&slippage=${slippage} `,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${getTokenForFiber()}`,
      },
    }
  );
}

export async function regenerateSwap(txHash, chainId) {
  return axios.put(
    `${defaultEndPointDetails.baseUrl}/api/v1/community-member/multiSwap/transactions/regenerate/swap/and/withdraw/${txHash}?chainId=${chainId}`,
    {},
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${await getValidTokenV3()}`,
      },
    }
  );
}

export async function getGasFee(
  sourceNetworkChainId,
  sourceTokenContractAddress,
  sourceAmount,
  sourceAmountOut,
  sourceOneInchData,
  sourceAssetType,
  sourceOneInchSelector,
  sourceWalletAddress,
  destinationNetworkChainId,
  destinationTokenContractAddress,
  destinationOneInchSelector,
  destinationAmountIn,
  destinationAmountOut,
  destinationOneInchData,
  destinationAssetType,
  destinationWalletAddress
) {
  return axios.get(
    `${defaultEndPointDetails.fiberBaseUrl}/api/v1/gasFees/estimation?destinationNetworkChainId=${destinationNetworkChainId}&destinationWalletAddress=${destinationWalletAddress}&destinationTokenContractAddress=${destinationTokenContractAddress}&destinationAmountIn=${destinationAmountIn}&destinationAmountOut=${destinationAmountOut}&destinationAssetType=${destinationAssetType}&destinationOneInchData=${destinationOneInchData}&sourceNetworkChainId=${sourceNetworkChainId}&sourceTokenContractAddress=${sourceTokenContractAddress}&sourceAmount=${sourceAmount}&sourceOneInchData=${sourceOneInchData}&sourceAssetType=${sourceAssetType}&sourceWalletAddress=${sourceWalletAddress}&sourceAmountOut=${sourceAmountOut}&sourceOneInchSelector=${sourceOneInchSelector}&destinationOneInchSelector=${destinationOneInchSelector}`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-type": "Application/json",
        Authorization: `Bearer ${getTokenForFiber()}`,
      },
    }
  );
}
